<template>
  <vx-card
    title="Aktifitas Terbaru"
    subtitle="Berdasarkan 50 aktifitas terbaru di sistem"
    class="mb-8"
  >
    <global-wrapper
      :loading="loading"
      :loadingType="'avatar-three-line'"
      :loadingList="4"
      :scrollable="true"
      height="400px"
    >
      <div
        class="w-full flex items-start mb-4"
        v-for="(data, key) in activitiesData"
        :key="key"
      >
        <vs-avatar name="Petugas" class="mr-5" size="40px"></vs-avatar>
        <div class="flex-1">
          <div class="flex">
            <div class="font-bold flex-1">{{ data.dari_pengguna }}</div>
          </div>
          <div class="flex flex-col">
            <div class="font-light text-grey italic">
              {{ data.tgl_aktifitas | moment }}
            </div>
            <div>
              Mendisposisikan berkas berkas kepada
              <strong>{{ data.ke_pengguna }}</strong> dengan posisi
              <strong>{{ data.ke_posisi }}</strong>
            </div>
          </div>
        </div>
      </div>
    </global-wrapper>
  </vx-card>
</template>


<script>
import moment from 'moment';

export default {
  data() {
    return {
      loading: false,
      activitiesData: []
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData(){
      this.loading = true;
      const res = await this.$http.get('/dashboard/latest-activities-data');
      this.activitiesData = res.data.data;
      this.loading = false;
    }
  },
  filters: {
    moment(date) {
      return moment(date).locale('id').fromNow()
    },
  },
}
</script>
